import { useTranslation } from 'react-i18next';
import { Box, brandMark, palette, Typography, fontStacks } from '@munifocus/ui';

/** The MuniFocus arc mark — concentric arcs + centre dot, matching the marketing site. */
function ArcMark({ width = 30 }: { width?: number }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 48 32"
      fill="none"
      sx={{ width, height: (width * 32) / 48, flexShrink: 0 }}
      aria-hidden="true"
    >
      <path
        d="M5 25 A19 19 0 0 1 43 25"
        stroke={palette.border.onLight}
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M13 25 A11 11 0 0 1 35 25"
        stroke={brandMark.onLight}
        strokeWidth={3}
        strokeLinecap="round"
      />
      <circle cx={24} cy={25} r={3.6} fill={brandMark.onLight} />
    </Box>
  );
}

/**
 * The official "MuniFocus Government Portal" lockup (arc mark + wordmark), matching
 * `docs/design-system/assets/wordmark.svg`: MuniFocus in ink/teal, the Government Portal
 * product name in brand teal at a lighter weight.
 */
export function BrandMark() {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
      <ArcMark />
      <Typography
        component="div"
        sx={{
          fontFamily: fontStacks.display,
          fontWeight: 700,
          // "Portail gouvernemental" is ~40px wider than "Government Portal" and the
          // lockup never wraps, so step down on phones to keep it inside a 375px screen.
          fontSize: { xs: 17, sm: 19 },
          lineHeight: 1.1,
          letterSpacing: '-0.01em',
          color: palette.text.primary,
          whiteSpace: 'nowrap',
        }}
      >
        Muni
        <Box component="span" sx={{ color: brandMark.onLight }}>
          Focus
        </Box>
        <Box component="span" sx={{ color: palette.text.muted, fontWeight: 400, mx: 0.875 }}>
          ·
        </Box>
        <Box component="span" sx={{ color: brandMark.onLight, fontWeight: 500 }}>
          {t('gov.nav.portalName')}
        </Box>
      </Typography>
    </Box>
  );
}
